"use client";

import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  const [offsetY, setOffsetY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const matchesQuery = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if (matchesQuery) {
        setOffsetY(0);
        return;
      }
      setOffsetY(window.scrollY * 0.2);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section ref={ref} className="relative w-full h-screen overflow-hidden">
      {}
      <div ref={parallaxRef} className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1516646/img/hvac_unit_daylight_hero.png)]" style={{
      transform: `translateY(${offsetY}px)`,
      willChange: "transform"
    }} aria-hidden="true" />

      {}
      <div className="absolute inset-0 bg-black/40" aria-hidden="true" />

      {}
      <div className="relative z-10 flex items-center justify-center h-full px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          {}
          <h1 className={`font-display text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 transition-all duration-[150ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2.5"}`}>
            Expert HVAC Solutions for Pittsburgh
          </h1>

          {}
          <p className={`font-sans text-lg sm:text-xl md:text-2xl text-white/95 mb-8 transition-all duration-[150ms] ease-out delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2.5"}`}>
            Impeccable craftsmanship and customer satisfaction for residential and commercial climate control
          </p>

          {}
          <div className={`transition-all duration-[150ms] ease-out delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2.5"}`}>
            <Link to="/ContactPage">
              <Button size="lg" className="btn-primary text-base sm:text-lg px-8 py-4 shadow-medium transition-all duration-[120ms] ease-in-out hover:-translate-y-0.5 hover:shadow-strong active:translate-y-0 motion-reduce:hover:translate-y-0 motion-reduce:hover:shadow-medium">
                Get a Free Consultation
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}